import '../Modals/DuplicateModal.scss';
import * as R from 'ramda';
import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { MdWarning } from 'react-icons/md';
import { Button } from '@Components/Button/Button';
import { Appearance, Design } from '@Components/designConstants';
import { ValidationErrors } from '../Validation/ValidationErrors';
import { FormContext } from '../wto-form-context';

interface DuplicateRuleModalProps {
  show: boolean;
  closeModal: () => void;
  index: number;
  showRuleCards: boolean[];
  setShowRuleCards: Dispatch<SetStateAction<boolean[]>>;
}

export const DuplicateRuleModal = ({
  show,
  closeModal,
  index,
  showRuleCards,
  setShowRuleCards
}: DuplicateRuleModalProps) => {
  const [duplicateRuleName, setDuplicateRuleName] = useState<string>('');
  const [validationErrors, setValidationErrors] = useState<string[]>([]);
  const { wtoFormObj, setWtoFormObj } = useContext(FormContext);

  const confirmDuplication = () => {
    if (duplicateRuleName.length === 0) {
      setValidationErrors(['Rule Name cannot be left blank']);
    } else {
      const newWtoFormObj = R.clone(wtoFormObj);
      const clonedRule = R.clone(wtoFormObj.rules[index]);
      clonedRule.rule_name = duplicateRuleName;
      const insertedRules = [
        ...newWtoFormObj.rules.slice(0, index + 1),
        clonedRule,
        ...newWtoFormObj.rules.slice(index + 1)
      ];
      // RuleCard keys Edit/Delete/reorder off rule_order as the array index -- remap all of them.
      newWtoFormObj.rules = insertedRules.map((rule, orderIndex) => ({
        ...rule,
        rule_order: `${orderIndex}`
      }));
      setWtoFormObj(newWtoFormObj);
      setShowRuleCards([
        ...showRuleCards.slice(0, index + 1),
        true,
        ...showRuleCards.slice(index + 1)
      ]);
      closeModal();
    }
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      className='duplicate-modal'
      data-testid='duplicate-rule-modal'
    >
      <Modal.Header closeButton>
        <Modal.Title>Duplicate Rule</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ValidationErrors validationErrors={validationErrors} />
        <div className='wto-info-box warning'>
          <div className='icon'>
            <MdWarning color='orange' className='alertIcon' />
          </div>
          <p className='message'>
            Before duplicating this rule, please enter unique values for the following fields:
          </p>
        </div>
        <Form className='form'>
          <Row>
            <Form.Group as={Col}>
              <Form.Label>Rule Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Rule Name'
                onChange={e => setDuplicateRuleName(e.target.value)}
              />
            </Form.Group>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={closeModal}>
          Cancel
        </Button>
        <Button onClick={confirmDuplication}>Confirm</Button>
      </Modal.Footer>
    </Modal>
  );
};
